export default __webpack_public_path__ + "static/media/logo-japan.a481a654.svg";